import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'react-bootstrap';
/* import CourseDetailsBg from 'assets/img/e-learning/course-details-bg.png';
import playicon from 'assets/img/icons/play.svg';
import beach from 'assets/video/beach.mp4';
import beachPoster from 'assets/video/beach.jpg'; */
import Background from 'components/common/Background';
import { Link } from 'react-router-dom';
import StarRating from 'components/common/StarRating';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import ProductImage from '../ProjectImage';
import Flex from 'components/common/Flex';
import Avatar, { AvatarGroup } from 'components/common/Avatar';
import user1 from 'assets/img/team/1-thumb.png';
import user2 from 'assets/img/team/2-thumb.png';
import user3 from 'assets/img/team/3-thumb.png';
import user4 from 'assets/img/team/4-thumb.png';
import user5 from 'assets/img/team/5-thumb.png';
import user6 from 'assets/img/team/25-thumb.png';
import user7 from 'assets/img/team/14-thumb.png';
import user8 from 'assets/img/team/9.jpg';
//import ModalVideoContent from '../../ModalVideoContent';  .substring(0, 152)

const socials = [
 {
  title: 'Website',
  icon: 'globe',
  url: '#!'
 },
 {
  title: 'LinkedIn',
  icon: ['fab', 'linkedin'],
  url: '#!'
 },
 {
  title: 'Facebook',
  icon: ['fab', 'facebook'],
  url: '#!'
 },
 {
  title: 'Instagram',
  icon: ['fab', 'instagram'],
  url: '#!'
 }
];

const CompanyBanner = ({ data }) => {
 /* const [showModal, setShowModal] = useState(false);
 const [showExcerpt, setShowExcerpt] = useState(false); */
 return (
  <Card className="mb-3 light bg-black">
   <Card.Header className="position-relative min-vh-50 mb-7">
    <Background image={data.banner} className="rounded-3" style={{ filter: 'brightness(0.8)' }} />
    <Flex
     wrap="wrap"
     justifyContent="center"
     alignItems="end"
     className="mt-md-3 ms-md-3 px-3 w-100 position-absolute top-100 start-0 translate-middle-y z-index-1"
    >
     <Avatar
      size="5xl"
      src={data.logo}
      mediaClass="img-thumbnail shadow-sm"
      className="rounded-circle"
      style={{ boxShadow: '-2px -5px 20px #222' }}
     />
     <div className="flex-fill border-sm-start border-start-2 ps-sm-3 ms-sm-3 ps-2 mb-2 mt-3 mt-md-0">
      <h3 className="mb-0 text-white text-capitalize">{data.name.toLowerCase()}</h3>
      <p className="text-white fw-semi-bold fs--1 mb-2">
       <span className="me-1">{4.5}</span>
       <StarRating readonly rating={4.5} />
       <span className="text-info ms-2">({(78259).toLocaleString()} reseñas)</span>
      </p>
      <AvatarGroup>
       <Avatar className="flex-shrink-0" src={user1} size="l" />
       <Avatar className="flex-shrink-0" src={user2} size="l" />
       <Avatar className="flex-shrink-0" src={user3} size="l" />
       <Avatar className="flex-shrink-0" src={user4} size="l" />
       <Avatar className="flex-shrink-0" src={user5} size="l" />
       <Avatar className="flex-shrink-0" src={user6} size="l" />
       <Avatar className="flex-shrink-0" src={user7} size="l" />
       <Avatar className="flex-shrink-0" src={user8} size="l" />
       <Avatar className="flex-shrink-0" name="Emma Watson" size="l" />
      </AvatarGroup>
     </div>
    </Flex>
   </Card.Header>
   <Card.Body className="pb-1">
    <Flex justifyContent="start" className="mt-5 mt-md-0">
     <ul className="list-unstyled mb-0 d-flex flex-wrap flex-xxl-column gap-3 justify-content-center">
      {socials.map(({ url, icon, title }) => (
       <li key={title}>
        <Button className="text-500 hover-primary fw-semi-bold font-base" variant="link" size="sm" as={Link} to={url}>
         <FontAwesomeIcon icon={icon} className="me-2" />
         {title}
        </Button>
       </li>
      ))}
     </ul>
    </Flex>
   </Card.Body>
  </Card>
 );
};

CompanyBanner.propTypes = {
 data: PropTypes.shape({
  name: PropTypes.string,
  excerpt: PropTypes.string,
  rating: PropTypes.number,
  review: PropTypes.number,
  thumbnail: PropTypes.shape({
   image: PropTypes.string
  }),
  banner: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired
 })
};

export default CompanyBanner;
